<template>
  <div class="pb-3">
    <div>
      <v-flex v-if="!itsPartialPayment" :class="isSmAndDown ? 'xs12' : 'xs6'">
        <h4
          v-if="
            orderData && orderData.orderData && orderData.orderData.hash_pedido
          "
          class="checkout-h4 confirmation-subtitle mb-0"
        >
          {{ delivery.name }}
        </h4>
        <!-- <h4 class="checkout-h4 confirmation-subtitle">{{ delivery.subtitle }}</h4> -->
        <!-- <p class="grey--text">{{ delivery.summary }}</p> -->
        <h4
          v-if="
            orderData && orderData.orderData && !orderData.orderData.hash_pedido
          "
          class="checkout-h4 confirmation-subtitle"
        >
          Seus ingressos foram enviados para o email {{ postOrder.email }}
        </h4>
        <p
          v-if="
            orderData && orderData.orderData && !orderData.orderData.hash_pedido
          "
          class="grey--text"
        >
          Caso não tenha recebido o email, acesse/crie sua conta para acessar
          seus ingressos.
        </p>
      </v-flex>
      <v-spacer></v-spacer>
      <v-flex :class="isSmAndDown ? 'xs12' : ''">
        <div v-if="!itsPartialPayment" class="btn-next-step pb-0">
          <v-btn
            v-if="
              orderData &&
                orderData.orderData &&
                orderData.orderData.hash_pedido
            "
            block
            round
            class="normal-text"
            color="primary"
            dark
            depressed
            target="_blank"
            :href="ticketUrl"
            >{{
              orderData.orderData && orderData.orderData.ticketsCaption
                ? orderData.orderData.ticketsCaption
                : 'Ver Ingressos'
            }}</v-btn
          >
          <v-btn
            v-if="
              orderData &&
                orderData.orderData &&
                !orderData.orderData.hash_pedido
            "
            block
            round
            class="normal-text"
            color="primary"
            dark
            depressed
            target="_blank"
            :href="urlSite"
            >Acessar Conta</v-btn
          >
        </div>
        <div style="width: 100% !important" v-if="itsPartialPayment">
          <div class="pt-2 pr-5">
            <span
              >Este pedido ainda possui um saldo de
              {{ (itsPartialPayment * 100 - partialValue * 100) | currency }} à
              pagar</span
            >
          </div>
          <div class="pt-2 pr-5">
            <span
              >Para realizar um novo pagamento nesse pedido, acesse o link
              abaixo</span
            >
          </div>
          <div class="pt-2 pr-5" justify-center>
            <v-btn
              @click="goToPayment"
              round
              depressed
              color="primary"
              style="text-transform: none"
              >Fazer novo pagamento</v-btn
            >
            <v-btn
              @click="clickCopy"
              round
              depressed
              color="primary"
              style="text-transform: none"
              >Copiar Link</v-btn
            >
          </div>
        </div>
      </v-flex>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: ['ticketUrl', 'itsPartialPayment'],
  data() {
    return {
      delivery: {
        name: 'Ingresso Digital',
        // subtitle: 'Identifique os ingressos',
        // summary:
        //   'Nomeie os ingressos para quem utilizará o ingresso no dia do evento.',
      },
    };
  },
  computed: {
    ...mapGetters([
      'postOrder',
      'userProps',
      'orderData',
      'partialValue',
      'store',
    ]),
    urlSite() {
      if (this.userProps) {
        let encode = btoa(JSON.stringify(this.userProps));
        return `https://site.blueticket.com.br/ingressos?register=${encode}`;
      } else return 'https://site.blueticket.com.br/ingressos';
    },
  },
  methods: {
    goToPayment() {
      window.open(
        `${this.store.checkoutUrl}/order/${this.orderData.orderData.hash_pedido}`,
        '_self'
      );
    },

    clickCopy() {
      navigator.clipboard.writeText(
        `${this.store.checkoutUrl}/order/${this.orderData.orderData.hash_pedido}`
      );
    },
  },
};
</script>
